<template>
  <b-modal
    size="xl"
    title="Dopasuj kolumny z pliku do modelu jakości"
    :visible="visible"
    @hide="hide"
  >
    <b-form-row class="mb-2 headers">
      <b-col md="6">Nazwa atrybutu</b-col>
      <b-col md="2">Zmapuj wartość atrybutu</b-col>
      <b-col md="4">Pierwsza wartość</b-col>
    </b-form-row>

    <b-form-row
      v-for="column in columns"
      :key="column.key"
      class="mb-2 import-data"
    >
      <b-col md="6">{{ column.label }} ({{ column.key }})</b-col>
      <b-col md="2">
        <b-select
          v-model="mappedColumns[column.key]"
          class="w-100 cursor-pointer"
          :class="{
            'border-danger': Boolean(mappingError[column.key])
          }"
        >
          <option :value="undefined">Wybierz</option>
          <option
            v-for="field in fields"
            :key="field.key"
            :value="field"
            class="option-wrap"
          >
            {{ field.key }}
          </option>
        </b-select>
        <small class="text-danger" v-show="mappingError[column.key]">{{
          mappingError[column.key]
        }}</small>
      </b-col>
      <b-col md="4" class="col-form-label">
        {{ firstValuesByColumnKey[column.key] }}
      </b-col>
    </b-form-row>

    <template slot="modal-footer">
      <b-btn variant="primary" @click="save">Zastosuj</b-btn>
      <b-btn variant="outline-secondary" @click="cancel">Anuluj</b-btn>
    </template>
  </b-modal>
</template>

<script>
import { WINDOW_NOTIFICATION_SHOW } from '../store/mutations.type';

const MISSING_MAPPING = 'Brakujące dopasowanie.';
const DUPLICATED_MAPPING = 'Zduplikowane dopasowanie.';

export default {
  name: 'MapColumnsModal',
  props: {
    visible: Boolean,
    expectedColumns: Array,
    fields: Array
  },
  data() {
    return {
      mappedColumns: {},
      mappingError: {}
    };
  },
  computed: {
    columns() {
      return this.expectedColumns.filter(column => 'dictionary' in column);
    },
    firstValuesByColumnKey() {
      const firstValues = {};
      this.columns.forEach(column => {
        const mappedField = this.mappedColumns[column.key];
        firstValues[column.key] = mappedField
          ? mappedField.first_value
          : 'Brak';
      });
      return firstValues;
    }
  },
  methods: {
    hide() {
      this.$emit('hide');
    },
    prefillMappedColumns() {
      // Initialize mappedColumns reactively
      this.mappedColumns = {};
      let atLeastOneGuess = false;
      this.columns.forEach(column => {
        const columnKey = column.key;
        const guessedField = this.fields.find(field =>
          columnKey.includes(field.key)
        );

        if (guessedField) {
          this.$set(this.mappedColumns, columnKey, guessedField);
          atLeastOneGuess = true;
        }
      });

      return atLeastOneGuess;
    },
    validateMapping() {
      this.mappingError = {}; // Reset errors before validation
      let missingMapping = false;

      this.columns.forEach(column => {
        if (!this.mappedColumns[column.key]) {
          missingMapping = true;
          this.$set(this.mappingError, column.key, MISSING_MAPPING);
        }
      });

      if (missingMapping) {
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          type: 'error',
          title: 'Uwaga.',
          message: 'Nie wszystkie kolumny zostały dopasowane.'
        });
        return false;
      }

      const duplicatedKeys = Object.entries(this.mappedColumns).reduce(
        (acc, [key, value], index, arr) => {
          const isDuplicated = arr.find(
            ([_, field], i) => field.key === value.key && i !== index
          );
          if (isDuplicated) return [...acc, key];
          return acc;
        },
        []
      );

      if (duplicatedKeys.length) {
        duplicatedKeys.forEach(key =>
          this.$set(this.mappingError, key, DUPLICATED_MAPPING)
        );

        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          type: 'error',
          title: 'Uwaga.',
          message: 'Niektóre dopasowania są zduplikowane.'
        });
        return false;
      }

      return true;
    },
    reset() {
      this.hide();

      // Reset mappedColumns reactively
      this.mappedColumns = this.columns.reduce((acc, column) => {
        acc[column.key] = undefined;
        return acc;
      }, {});

      this.mappingError = {};
    },
    cancel() {
      this.reset();
    },
    save() {
      if (this.validateMapping()) {
        this.$emit('save', this.mappedColumns);
        this.reset();
      }
    }
  },
  watch: {
    visible(newValue) {
      if (newValue) {
        const atLeastOneGuess = this.prefillMappedColumns();
        if (atLeastOneGuess) {
          this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
            type: 'warn',
            title: 'Uwaga.',
            message:
              'Niektóre nazwy kolumn zostały dopasowane automatycznie - zweryfikuj dopasowanie'
          });
        }
      }
    }
  }
};
</script>
